import TextInput from "./Fields/TextInput";
import SelectInput from "./Fields/SelectInput";
import FileInput from "./Fields/FileInput";
import CameraInput from "./Fields/CameraInput";
import FingerprintInput from "./Fields/FingerprintInput";
import MultiselectInput from "./Fields/MultiselectInput";
import RangeInput from "./Fields/RangeInput";

const CustomField = ({ field, setFieldValue, values }) => {

  switch (field.type) {
    case "text":
    case "email":
    case "number":
    case "time":
    case "password": return (<TextInput field={field} setFieldValue={setFieldValue} values={values} />);
    case "range": return (<RangeInput field={field} setFieldValue={setFieldValue} values={values} />);
    case "custom": return (<MultiselectInput field={field} setFieldValue={setFieldValue} values={values} />);
    case "select": return (<SelectInput field={field} setFieldValue={setFieldValue} values={values} />);
    case "file": return (<FileInput field={field} setFieldValue={setFieldValue} values={values} />);
    case "camera": return (<CameraInput field={field} setFieldValue={setFieldValue} values={values} />);
    case "finger": return (<FingerprintInput field={field} setFieldValue={setFieldValue} values={values} />);
    default: return null;
  }
};

export default CustomField;